<template>
  <div class="container-fluid" v-if="testimonialRows.length">
    <div class="row">
      <div class="col">
        <h5>{{ $t('PAGE_home_testimonials_title') }}</h5>
      </div>
    </div>
    <div class="row">
      <b-col
        :class="{
          'mb-4': true,
          'col-xl': testimonialRows[currentTesimonialRowIndex].length === 3,
          'col-xl-8': testimonialRows[currentTesimonialRowIndex].length === 2,
          'col-xl-4': testimonialRows[currentTesimonialRowIndex].length === 1,
          'col-lg': testimonialRows[currentTesimonialRowIndex].length === 2,
          'col-lg-6': testimonialRows[currentTesimonialRowIndex].length === 1,
          'col-md': testimonialRows[currentTesimonialRowIndex].length === 2,
          'col-md-6': testimonialRows[currentTesimonialRowIndex].length === 1,
        }"
      >
        <b-card-group deck>
          <testimonial-card
            v-for="testimonial in testimonialRows[currentTesimonialRowIndex]"
            :key="testimonial.id"
            :Id="testimonial.id"
            :CardTitle="testimonial.title"
            :CardTagline="testimonial.tagline"
            :CardText="testimonial.description"
            :ImgSrc="testimonial.image"
            :ImgHeight="testimonial.image_height"
            :ImgWidth="testimonial.image_width"
            ImgAlt="Testimonial Image"
          />
        </b-card-group>
      </b-col>
    </div>
    <div class="row" v-if="testimonialRows.length > 1">
      <div class="col text-right">
        <b-button
          :disabled="
            testimonialRows[0].map(t => t.id).includes(testimonialIndex)
          "
          @click="
            testimonialIndex =
              testimonialRows[currentTesimonialRowIndex - 1][0].id
          "
          variant="link"
        >
          <i class="fa fa-chevron-left" />
        </b-button>
        <b-button-group>
          <b-button disabled variant="outline-dark">
            {{ currentTesimonialRowIndex + 1 }}
          </b-button>
        </b-button-group>
        <b-button
          :disabled="
            testimonialRows[testimonialRows.length - 1]
              .map(t => t.id)
              .includes(testimonialIndex)
          "
          @click="
            testimonialIndex =
              testimonialRows[currentTesimonialRowIndex + 1][0].id
          "
          variant="link"
        >
          <i class="fa fa-chevron-right" />
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import chunk from 'lodash/chunk';

import TestimonialCard from '@/components/TestimonialCard';

export default {
  name: 'testimonials',
  data() {
    return {
      testimonialIndex: 1,
    };
  },
  components: {
    TestimonialCard,
  },
  computed: {
    ...mapGetters(['testimonials']),
    testimonialRows() {
      if (['sm'].includes(this.$mq)) return chunk(this.testimonials, 1);

      if (['md', 'lg'].includes(this.$mq)) return chunk(this.testimonials, 2);

      return chunk(this.testimonials, 3) || [];
    },
    currentTesimonialRowIndex() {
      const index = this.testimonialRows.findIndex(t =>
        t.map(t => t.id).includes(this.testimonialIndex)
      );
      return index > 0 ? index : 0;
    },
  },
};
</script>

<style scoped>
.chevron {
  transition: transform 0.4s;
}

.isOpen {
  transform: rotateZ(-180deg);
}
</style>



// WEBPACK FOOTER //
// src/components/Testimonials.vue